<template>
  <CModal
    :show.sync="teacherEditModal"
    :centered="true"
    :title="`${user.name}  ${user.lastname} - ${user.nationalId}`"
    size="md"
  >
    <CForm class="add-homework-modal text-right">
      <UploadAvatar
        v-if="teacherEditModal === true"
        v-model="form.profileImageUrl"
        @upload-avatar="onUploadAvatar"
        cat="PI"
      />
      <CInput
        v-model="form.mobile"
        label="شماره تماس"
        class="text-sm"
        maxlength="11"
      />
    </CForm>

    <template #footer>
      <CButton
        :disabled="loading"
        @click="onEditTeacher"
        color="primary"
        class="px-5"
      >
        تایید
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import UploadAvatar from "../../UploadAvatar/UploadAvatar.vue";
export default {
  components: { UploadAvatar },
  props: {
    value: {
      type: Boolean,
    },
    user: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
      loading: false,
    };
  },
  computed: {
    teacherEditModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    user(newvalue) {
      this.form = {
        mobile: newvalue.mobile,
        profileImageUrl: newvalue.profileImageUrl,
      };
    },
  },
  methods: {
    async onEditTeacher() {
      try {
        this.loading = true;
        const payload = {
          id: this.user.id,
          mobile: this.form.mobile,
          profileImageUrl: this.form.profileImageUrl,
        };
        await axios.put(`/teacher/${this.user.id}`, payload);
        this.teacherEditModal = false;
        this.$emit("get-teacher");
        this.$emit("close-view-modal");
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onUploadAvatar(file) {
      this.form.profileImageUrl = file;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .vpd-container {
    .vpd-content {
      border-radius: 8px;
      .vpd-header {
        border-radius: 8px 8px 0 0;
      }
    }
  }
  .text-sm {
    font-size: 14px;
  }
}
</style>
